import uhOh from '@/assets/images/uh-oh.jpeg'

export function PageNotFound() {
  return (
    <div className="flex h-full w-full flex-col items-center">
      <img alt="uh oh" className="w-full mb-3 object-cover" src={uhOh} />
      <h1 className="text-header-l font-medium">Page not Found</h1>
      <p className="mt-4 font-medium">Whoops! This page does not exist.</p>
    </div>
  )
}
